var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-template"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"invite-template__wrapper"},[_c('nuxt')],1),_vm._v(" "),_c('LoaderComponent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-template__nav"},[_c('img',{staticClass:"invite-template__logo",attrs:{"src":require("assets/images/logo-login.svg"),"alt":"SiteCircle"}})])
}]

export { render, staticRenderFns }